import {
    Box,
    Typography,
} from '@mui/material'
import {Image} from 'antd'
import HowWork from '../../../assets/personal-loan/howwork-banner.jpg'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMHowWork: React.FC = () => {

    const { t } = useTranslation()

    const data = [
        {
            'number': '01',
            'title': t('t53'),
            'content': t('t54')
        },
        {
            'number': '02',
            'title': t('t55'),
            'content': t('t56')
        },
        {
            'number': '03',
            'title': t('t57'),
            'content': t('t58')
        },
        {
            'number': '04',
            'title': t('t59'),
            'content': t('t60')
        }
    ]

    const renderItem = (index: number) => {
        return (
            <Box key={index} sx={{
                display: 'flex',
                flexDirection: 'row',
                paddingTop: '40px'
            }}>
                <Box width={70} height={70} sx={{
                    border: '1px solid #FBBF23',
                    borderRadius: '35px',
                    alignContent: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center'
                }}>
                    <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'center'}>
                        {data[index]['number']}
                    </Typography>
                </Box>
                <Box sx={{
                    flex: '1',
                    paddingLeft: '25px'
                }}>
                    <Typography color={'#141F39'} fontSize={20} fontWeight={600} textAlign={'left'}>
                    {data[index]['title']}
                    </Typography>

                    <Typography color={'#6B6B6B'} fontSize={16} fontWeight={400} textAlign={'left'}>
                    {data[index]['content']}
                    </Typography>
                </Box>
            </Box>
        )
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#FFFDF7'
            }}
        >
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'row',
                paddingTop: '80px',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingBottom: '60px'
            }}>
                <Image src={HowWork} width={isTablet ? 500 : 606} height={isTablet ? 534 : 647} style={{borderRadius: '10px', objectFit: 'cover'}} alt='' preview={false}></Image>
                <Box width={isTablet ? 30 : 72}></Box>
                <Box sx={{
                    flex: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'start',
                    flexDirection: 'column'
                }}>
                    <Typography color={'#141F39'} fontSize={32} fontWeight={700} textAlign={'left'}>
                        {t('t51')}
                    </Typography>

                    <Typography color={'#141F39'} fontSize={16} fontWeight={400} textAlign={'left'} paddingTop={'0px'} paddingBottom={'8px'}>
                        {t('t52')}
                    </Typography>

                    {data.map((item, index) => (
                        renderItem(index)
                    ))}

                </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMHowWork
